import {environment} from '../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IReservation } from '../models/reservation.model';

@Injectable({
  providedIn : 'root'
})

export class ReservationService {

  constructor(private http: HttpClient) {}

  getReservation(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/reservation` + (size ? '?page=' + page + '&size=' + size : ''), {'headers': headers});
  }

  // getAllReservation_v1(page: number, size: number) {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  //   return this.http.get<any>(`${environment.url}/v1/reservation/all-reservations`+ (size ? '?page=' + page + '&size=' + size : ''), {'headers': headers});
  // }

  getAllReservation_v1(page: number, size: number, startDate?: string, endDate?: string, reservationSearchText?: string, statusSearchText?: string): Observable<any> {
      let headers = new HttpHeaders();
      headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
      let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

      if (startDate) {
        params = params.set('startDate', startDate);
      }
      if (endDate) {
        params = params.set('endDate', endDate);
      }
      if (reservationSearchText) {
        params = params.set('reservationSearchText', reservationSearchText);
      }
      if (statusSearchText) {
        params = params.set('statusSearchText', statusSearchText);
      }


      return this.http.get(`${environment.url}/v1/reservation/all-reservations`, { params , headers} );
  }

  getReservationUser(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/reservation/connected`, {'headers': headers});
  }

  getReservationUnpaid(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/reservation/notPaid`, {'headers': headers});
  }

  getReservationPaid(id: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/reservation/paid/` + id, null, {'headers': headers});
  }

  getReservationProfessionnel() {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/reservation/forMe`, {'headers': headers});
  }

  getAllReservation() {
    return this.http.get<any>(`${environment.url}/v1/reservation`);
  }
  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/reservation` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  saveReservation(Reservation: IReservation) {
  //  console.log('Reservation save reservation');
  //   console.log(Reservation);

    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/reservation`, Reservation, {'headers': headers});
  }

  getIdReservation(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/reservation/` + idA, {'headers': headers});
  }

  updateReservation(Reservation: IReservation) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/reservation/` + Reservation.id, Reservation, {'headers': headers});
  }

  reporterClientReservation(Reservation: IReservation) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/reservation/reportCustomer/` + Reservation.id, Reservation, {'headers': headers});
  }

  reporterVendeurReservation(Reservation: IReservation) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/reservation/reportSeller/` + Reservation.id, Reservation, {'headers': headers});
  }

  confimerReservation(id: Number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/reservation/confirm/` + id, null, {'headers': headers});
  }

  annulerReservation(id: Number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/reservation/cancel/` + id, null, {'headers': headers});
  }

  deleteReservation(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete<IReservation>(`${environment.url}/reservation/` + id, {'headers': headers});
  }

  // Liste des réservation faite entre deux date
  getReservationByDates(startDate: any, endDate: any, page: number, size: number ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/reservation/reservation-by-date?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }

}
